"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Refresh = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Refresh = function Refresh(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.071 8.001a1.002 1.002 0 00-1.131.85c-.417 2.935-2.971 5.15-5.94 5.15a6.001 6.001 0 01-3.838-1.399l1.679-1.678A.542.542 0 005.458 10H.541a.54.54 0 00-.541.541v4.917c0 .481.583.724.924.382l1.815-1.815A8.008 8.008 0 008 16c3.959 0 7.364-2.953 7.921-6.868a1.001 1.001 0 00-.85-1.13zM16 .542V5.46a.54.54 0 01-.541.541h-4.917a.541.541 0 01-.383-.924l1.679-1.678A6.003 6.003 0 008 2C5.03 2 2.476 4.214 2.059 7.15a1.001 1.001 0 01-1.98-.282C.635 2.953 4.041 0 8 0c1.954 0 3.818.717 5.26 1.975L15.076.16A.542.542 0 0116 .542z",
    fill: "currentColor"
  }));
};

exports.Refresh = Refresh;
var _default = Refresh;
exports.default = _default;